import { render } from "./App.vue?vue&type=template&id=0e8da92a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martin/Coding/work/kraiburg-website-typo3/extensions/dealersearch/Resources/Private/Vue/dealersearch-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__